
<app-dave-list-card
    [HasSuffixButton]="hasSuffixButton"
    (Count)="Count.emit($event)"
    [Headline]="Headline"
    EmptyText="Keine {{Headline}} vorhanden"
    [Data]="data$ | async"
    [DisplayedCollums]="['Name', 'Description', 'EventDate', 'FileCount']"
    [TableHeaderCollumsMap]="{ Name: 'Name', Description: 'Beschreibung', EventDate: 'Datum', FileCount: 'Anhänge' }"
    [CustomCellTemplates]="{ EventDate: dateColumn }"
    [DefaultSortActive]="'EventDate'"
    [Clickable]="true"
    (EntryClicked$)="OpenEditEventDialog($event.entry, $event.element)"
    [IsExpandable]="IsExpandable"
    [Expanded]="Expanded"
    style="max-height: 50vh"
>

    <button *ngIf="eventType$ | async as type" [Disabled]="!canCreate" headerButton app-round-button (click)="OpenAddEventDialog()" [matTooltip]="type.Name + ' hinzufügen'">
        <app-double-icon [Icon]="type.ImagePath | icon" Icon2="plus"></app-double-icon>
    </button>
    <button headerButton app-round-button
            matTooltip="Filter"
            class="mat-badge-more-overlay"
            (click)="eventFilter.Toggle(); $event.stopPropagation();"
            [matBadge]="FilterAmount$ | async"
            [matBadgeHidden]="!(FilterAmount$ | async)"
            matTooltip="Filter"
            [matBadgeOverlap]="true"
    >
        <fa-icon icon="filter"></fa-icon>
    </button>
</app-dave-list-card>
<app-filter-card UnlimitedHeight #eventFilter [Settings]="EventFilterSettings | async"
                 [Values]="EventFilterValues$ | async" (ValuesChange)="EventFilterValues$.next($event)"></app-filter-card>
<ng-template #dateColumn let-data="data"> {{ data.EventDate | date }}&nbsp; </ng-template>
